import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import {BeatLoader} from "react-spinners";
import { override } from '../helpers/utils.js';
import jwt_decode from "jwt-decode";
class OriginalTxn1 extends Component{
    constructor(props) {
        super(props);
        this.state ={
            OriginalTxnID:'',
            OriginalTxnList:[{value: '', label: 'Select'}],
            is_OriginalTxn_loading: true,
            OriginalTxnValue: [],
            OriginalTxnListOpen: false,
            OriginalTxnHeaderTitle: "Select [OriginalTxn]",
            object_code:[],
            OriginalTxnObject:[],
            search_object_code:[],
            OriginalTxn_name:""

        }
        this.closeOriginalTxnList = this.closeOriginalTxnList.bind(this);
    }

    componentDidUpdate() {
        const { OriginalTxnListOpen } = this.state;
        setTimeout(() => {
            if (OriginalTxnListOpen) {
                window.addEventListener('click', this.closeOriginalTxnList);
            } else {
                window.removeEventListener('click', this.closeOriginalTxnList);
            }
        }, 0);
    }

    componentDidMount() {
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        this.setState({
            userGroupName:decoded.userGroupName,
            object_code:decoded.object_code,
            object_type:decoded.object_type
        })
        this.getOriginalTxn(decoded.object_type,arrayCode,false,'',this.props.start_date,this.props.end_date);
    }
    restOriginalTxnFilter(){
        this.setState({
            OriginalTxnID: [],
        })
    }
    getOriginalTxn(object_type, object_code,is_search, search_value,start_date, end_date) {
        //alert(code); alert(type)
        if(is_search===false){
            this.setState({
                OriginalTxnID:[]
            })
        }
        this.setState({
//             search_code: code,
//             search_type: type,
            object_type: object_type,
            search_object_code: object_code
        })
        let selected_val = [];
        if(is_search===true){
            selected_val = this.state.OriginalTxnObject
        }
        this.setState({
            OriginalTxnList:[],
            is_OriginalTxn_loading: true
        })
        var url = '/filters/get-txn-summary-filters';

        axios.post(config.get('API_URL')+url, {
                user_type: object_type,
                object_code: object_code,
                filter_type: "original_transaction_id",
                is_search: is_search,
                search_value: search_value,
                start_date: start_date,
                end_date: end_date,
                is_current_date: this.props.is_current_date,
                selected_value: selected_val
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }

            }).then((response) => {
                let OriginalTxnList = [];
                //this.setState({OriginalTxnID:''});
                console.log('Response**',response)
                response.data.map((OriginalTxn,index) => {
                    OriginalTxnList.push({value: OriginalTxn.original_transaction_id, label: OriginalTxn.original_transaction_id})
                });
                let res = []
                if (Array.isArray(this.state.OriginalTxnID) && this.state.OriginalTxnID) {
                    const uniq = new Set(OriginalTxnList.map(e => JSON.stringify(e)));

                    OriginalTxnList = Array.from(uniq).map(e => JSON.parse(e));

                }
                this.setState({
                    OriginalTxnList:OriginalTxnList,
                    is_OriginalTxn_loading: false
                })
            }).catch((e)=>{
                console.log(e)
                this.setState({
                    is_OriginalTxn_loading: false
                })
            })
    }
    changeOriginalTxn(login_type, OriginalTxn_object, checked_item, e) {
        if (login_type === 'OriginalTxn') {
            let value='';
            let sidArray = [];
            if(OriginalTxn_object.length<1){
                value = null;
                sidArray = '';
            }
            else{
                OriginalTxn_object.map((sids, i) => {
                    sidArray.push(sids.value)
                });
            }
            this.setState({
                OriginalTxnID: sidArray,
                OriginalTxnValue:OriginalTxn_object,
                ciutidIds: '',
                ciutidValue: [],
                isChange: true
            });
        } else {
            let item_list = this.state.OriginalTxnID;
            let item_list_object = this.state.OriginalTxnObject;
            let checked_list = OriginalTxn_object.value;
            let checked_list_object = OriginalTxn_object;
            //console.log(checked_list);
            if(checked_item===false) {
                const newData = [OriginalTxn_object, ...this.state.OriginalTxnList.filter(item => item !== OriginalTxn_object)];
                this.setState({
                    OriginalTxnID: [...this.state.OriginalTxnID,OriginalTxn_object.value],
                    OriginalTxnObject: [...this.state.OriginalTxnObject,OriginalTxn_object],
                    isChange: true,
                    OriginalTxnList: newData,
                    OriginalTxn_name: OriginalTxn_object.label,

                });

            } else{
                let index = item_list.indexOf(checked_list);
                if (index > -1) {
                    item_list.splice(index, 1);
                    if(item_list.length<1) {
                        item_list='';
                    }
                    this.setState({
                        OriginalTxnID: item_list,

                    })
                }
                let index_object = item_list_object.indexOf(checked_list_object);
                if (index_object > -1) {
                    item_list_object.splice(index_object, 1);
                    if(item_list_object.length<1) {
                        item_list_object=[];
                    }
                    this.setState({
                        OriginalTxnObject: item_list_object,
                        isChange: true
                    })
                }
            }
            setTimeout(function() {
                this.props.onSelectOriginalTxn(this.state.OriginalTxnID);
            }.bind(this), 200);
            if (e.target.type === 'checkbox') {
                e.stopPropagation();
            }
        }

    }
    removeOriginalTxn(){
        const val = ''
        this.props.onSelectOriginalTxn(val);
        this.setState({
            originalTxnValue:[],
            OriginalTxnID:'',
            OriginalTxn_name:''
        });
    }
    OriginalTxnToggleList() {
        this.setState({
            OriginalTxnListOpen: !this.state.OriginalTxnListOpen,
        });
    }
    OriginalTxnFilterList(e){
        var value = e.target.value

        setTimeout(function() {
            this.getOriginalTxn(this.state.object_type, this.state.search_object_code,true, value,this.props.start_date,this.props.end_date);
        }.bind(this), 200);
    }
    closeOriginalTxnList() {
        this.setState({
            OriginalTxnListOpen: false,
        });
    }

    render() {
        //console.log(this.state.OriginalTxn_name);
        const OriginalTxn_lists = this.state.OriginalTxnList.map((OriginalTxn_object, index) => {
            // console.log("OriginalTxn_object");
            // console.log(OriginalTxn_object);
            var chks_input = <input type='checkbox' checked={false}/>
            var activeCls_s = 'dd-list-item';
            var checked_items = false;
            if(this.state.OriginalTxnID.includes(OriginalTxn_object.value) === true){
                chks_input = <input type='checkbox' checked={true}/>
                activeCls_s = "dd-list-item dd-list-active";
                checked_items = true;
            }
            return (
                <li key={index} className={activeCls_s} onClick={this.changeOriginalTxn.bind(this, '', OriginalTxn_object,checked_items)}>
                    {chks_input}
                    &nbsp;&nbsp;{OriginalTxn_object.label}
                </li>
            )
        })

        return(

            <div className="dd-wrapper">
                <div className="dd-header" onClick={() => this.OriginalTxnToggleList()}>
                    {this.state.OriginalTxnID==''?
                        <div className="dd-header-title">{this.state.OriginalTxnHeaderTitle}</div>:
                        <div className="dd-header-title">{this.state.OriginalTxnID.length} Selected</div>
                    }

                        <i className="fa fa-angle-down"></i>

                </div>

                {this.state.OriginalTxnListOpen ===true?
                    <div
                        role="list"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <input
                            className="dd-list-search-bar"
                            placeholder="Search"
                            onChange={(e) => this.OriginalTxnFilterList(e)}
                        />
                        <i className="fa fa-search" style={{position:"absolute", left:"195px",color: "rgb(204, 204, 204)", marginTop:"5px", zIndex:2}}></i>

                        {/*<div className="dd-scroll-list">*/}
                        <ul className="dd-list">
                            {this.state.is_OriginalTxn_loading===true?
                                <li>
                                    <BeatLoader
                                        css={override}
                                        sizeUnit={"px"}
                                        size={5}
                                        color={'#666666'}
                                        loading={this.state.is_OriginalTxn_loading}
                                    />
                                </li>: null}
                            {OriginalTxn_lists}

                        </ul> </div>: null }
                {/*</div>*/}
            </div>

        );
    }
}

export default OriginalTxn1;